

































import Vue from 'vue';

import { Track } from '@/config';

interface IMethods {
  link: () => void;
}

interface IComputed {
  dataAvailable: boolean;
  image: string;
}

interface IProps {
  track: Track | null;
}

export default Vue.extend<Record<string, unknown>, IMethods, IComputed, IProps>({
  name: 'CurrentTrack',

  props: {
    track: {
      type: Object,
      default: null,
    },
  },

  computed: {
    dataAvailable(): boolean {
      return this.track !== null;
    },

    image(): string {
      if (this.dataAvailable) {
        return (this.track as Track).image;
      }

      return '#';
    },
  },

  methods: {
    link(): void {
      window.open(`https://open.spotify.com/track/${(this.track as Track).id}`, '_blank');
    },
  },
});
